<template>
  <div class="details">
    <div class="details-head">
      <h5 class="details-title">{{ appoint.title }}</h5>
      <button
        type="button"
        class="details-close"
        aria-label="Schließen"
        @click="$emit('close')"
      >
        <b-icon-x />
      </button>
    </div>
    <ul class="details-meta">
      <li>
        <b-icon-clock class="meta-icon" />
        <span>{{ when }}</span>
      </li>
      <li v-if="appoint.location">
        <b-icon-geo-alt class="meta-icon" />
        <span>{{ appoint.location }}</span>
      </li>
    </ul>
    <div v-if="description" class="details-text" v-html="description"></div>
  </div>
</template>

<script>
import { sanitizeHtml } from "@/utils/richText";
import { formatEventRange } from "@/utils/calendarLayout";

export default {
  name: "AppointmentDetails",
  props: {
    appoint: {
      type: Object,
      required: true,
    },
  },
  computed: {
    when() {
      return formatEventRange(this.appoint);
    },
    description() {
      return sanitizeHtml(this.appoint.descriptionHTML);
    },
  },
};
</script>

<style lang="scss" scoped>
.details {
  padding: 1rem 1.25rem 1.25rem;
  border-top: 4px solid var(--warning);
}
.details-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}
.details-title {
  margin: 0 0 0.5rem;
  font-weight: bold;
  hyphens: auto;
}
.details-close {
  flex: none;
  border: 0;
  background: none;
  font-size: 1.5rem;
  line-height: 1;
  padding: 0 0.25rem;
  color: #888;
  cursor: pointer;
  &:hover {
    color: #333;
  }
}
.details-meta {
  list-style: none;
  margin: 0 0 0.75rem;
  padding: 0;
  font-size: 0.9rem;
  li {
    display: flex;
    gap: 0.5rem;
    align-items: baseline;
    margin-bottom: 0.25rem;
  }
}
.meta-icon {
  flex: none;
  color: var(--primary);
  transform: translateY(2px);
}
.details-text {
  font-size: 0.9rem;
  border-top: 1px solid #eee;
  padding-top: 0.75rem;
  max-height: 40vh;
  overflow-y: auto;
  ::v-deep p:last-child {
    margin-bottom: 0;
  }
  ::v-deep img {
    max-width: 100%;
    height: auto;
  }
}
</style>
